import { createApi } from '@reduxjs/toolkit/query/react';
import { createItemCategorymaster, listItemCategorymaster } from '../../graphql';
import { baseQuery } from '../../utils';
import type {
    ListItemCategorymasterQuery,
    ListItemCategorymasterQueryVariables,
    CreateItemCategorymasterMutation,
    CreateItemCategorymasterMutationVariables,
} from '../../graphql/API';

export const itemCategory = createApi({
    reducerPath: 'itemCategoryApi',
    baseQuery: baseQuery,
    tagTypes: ['itemcategory'],
    endpoints: (builder) => ({
        listItemCategorymaster: builder.query<
            ListItemCategorymasterQuery,
            ListItemCategorymasterQueryVariables
        >({
            query: (variables) => ({ body: listItemCategorymaster, variables }),
            keepUnusedDataFor: Infinity,
            providesTags: (result, error, { maincategory }) => [
                { type: "itemcategory", id: maincategory },
            ],
        }),
        createItemCategorymaster: builder.mutation<
            CreateItemCategorymasterMutation,
            CreateItemCategorymasterMutationVariables
        >({
            query: (variables) => ({ body: createItemCategorymaster, variables }),
            invalidatesTags: (result, error, { createItemCategorymasterInput }) => [
                { type: "itemcategory", id: createItemCategorymasterInput.maincategory },
            ],
        }),
    }),
});

export const {
    useCreateItemCategorymasterMutation,
    useListItemCategorymasterQuery,
} = itemCategory;

